import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sessionStorageKeys } from '@/reporting/sessionTrackingData';

const useUTMParams = () => {
  const { search } = useLocation();

  const handleUTMParams = useCallback(() => {
    const searchParams = new URLSearchParams(search);

    // only update session storage if there are any UTM params in the URL
    const hasAnyUTMParams = sessionStorageKeys.some((key) => searchParams.has(key));

    if (!hasAnyUTMParams) {
      return;
    }

    // remove any existing
    sessionStorageKeys.forEach((key) => {
      sessionStorage.removeItem(key);
    });

    // set any new
    sessionStorageKeys.forEach((key) => {
      const utmParamExists = searchParams.get(key);

      if (utmParamExists) {
        sessionStorage.setItem(key, utmParamExists);
      }
    });

    // update url
    const url = new URL(window.location.href);

    sessionStorageKeys.forEach((key) => {
      url.searchParams.delete(key);
    });
    window.history.replaceState({}, '', url.toString());
  }, [search]);

  useEffect(() => {
    handleUTMParams();
  }, [handleUTMParams]);

  return { handleUTMParams };
};

export default useUTMParams;
